import { shallowMount } from '@vue/test-utils';

import Component from './ShippingClaimsCard.vue';

let wrapper;

describe('ShippingClaimsCard', () => {
  beforeEach(() => {
    wrapper = shallowMount(Component);
  });

  test('render', () => {
    expect(wrapper.isVisible()).toBe(true);
  });
});
